/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment, useEffect } from '@wordpress/element';
import { InspectorControls, BlockControls, AlignmentControl, PanelColorSettings } from '@wordpress/block-editor';
import { PanelBody, SelectControl, TextControl } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { textAlign, textColor, extraClass, durationFormat, daysPlaceholderText, nightsPlaceholderText, hourPlaceholderText, minutePlaceholderText } = attributes;

	useEffect(() => {
        attributes.extraClass === '' 
        && setAttributes( { extraClass : props.clientId } )
    }, []);

	const textColorSettings = [
		{
			value: textColor,
			onChange: colorValue => setAttributes({ textColor: colorValue }),
			label: __( 'Text Color', 'wp-travel-blocks' )
		}
	];

	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<BlockControls>
					<AlignmentControl
						value={textAlign}
						onChange={(nextAlign) => {
							setAttributes({ textAlign: nextAlign });
						}}
					/>
				</BlockControls>
				{/* <InspectorControls>
					<PanelBody title={__('Filters', 'wp-travel-blocks')}>
						<SelectControl
							label={__('Select Format', 'wp-travel-blocks')}
							value={ durationFormat }
							options={ [
								{
									label: __('Days/Nights', 'wp-travel-blocks'),
									value:'day_night'
								}, {
									label: __('Hrs/Mins', 'wp-travel-blocks'),
									value:'hour_minute'
								}
							] }
							onChange={ (val) => setAttributes( { durationFormat: val } ) }
						/>
						{ durationFormat == "day_night" &&
						<Fragment>
							<TextControl
								label="Days Placeholder Text"
								value={ daysPlaceholderText }
								onChange={ ( value ) => setAttributes( { daysPlaceholderText: value } ) }
							/>
							<TextControl
								label="Nights Placeholder Text"
								value={ nightsPlaceholderText }
								onChange={ ( value ) => setAttributes( { nightsPlaceholderText: value } ) }
							/>
						</Fragment>
						}
						{ durationFormat == "hour_minute" &&
						<Fragment>
							<TextControl
								label="Hour Placeholder Text"
								value={ hourPlaceholderText }
								onChange={ ( value ) => setAttributes( { hourPlaceholderText: value } ) }
							/>
							<TextControl
								label="Minute Placeholder Text"
								value={ minutePlaceholderText }
								onChange={ ( value ) => setAttributes( { minutePlaceholderText: value } ) }
							/>
						</Fragment>
						}
					</PanelBody>	
					<PanelColorSettings
						title={__('Text Color', 'wp-travel-blocks')}
						colorSettings={textColorSettings}
						initialOpen={false}
					/>
				</InspectorControls> */}
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/trip-duration-date"
				attributes={ props.attributes }
			/>
		</div>
	);
}
